import React from "react";

let Online = React.createClass({
    render() {
        return (
            <div className="eo-online-container animate">
                <p className="text heading">You're online!</p>
                <div className="visual">
                    <span className="icon eo-icon-check"></span>
                </div>
            </div>
        );
    }
});

export default Online;


/** WEBPACK FOOTER **
 ** ./app/views/anonymous/views/features/components/Online.js
 **/